import { createModuleStore } from '../utils'
const createInitialFilterState = () => {
  return {
    selectedModes: [],
    selectedReaderTypes: [],
  }
}
export const useRemoteCommandConfigsStore = createModuleStore(
  'remote-command-configs',
  {
    type: 'Remote Command Configuration',
    pageHeading: 'Remote Command Configurations',
    noHistory: true,
    sortingOn: 'toolbar',
    uploadOptionsCsv: '',
    uri: '/remote-command-configs',
    serviceUri: '/remote-command-configs',
    statusesFilterName: 'statuses',
    listingModuleName: 'Config',
    listingActivityName: 'View Remote Command Configs',
    formModuleName: 'Config',
    formActivityName: 'Edit Remote Command Config',
    showRemoteCommandConfigModal: false,
    remoteCommandConfigRowData: null,
    allFields: [
      {
        key: 'body',
        title: 'BODY',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'label',
        title: 'LABEL',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'description',
        title: 'DESCRIPTION',
        visible: true,
        disabled: true,
        sortable: true,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {
    supportedPageFilters: {
      readerType: true,
      selectedReaderTypes: {
        type: 'readerTypes',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    resetPageFilters() {
      const store = useRemoteCommandConfigsStore()
      store.filters = createInitialFilterState()
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
        readerType: item.readerType,
        mode: item.mode,
        label: item.label,
        body: item.body,
        description: item.description,
      }
      return obj
    },
  },
  {
    fields: [
      {
        id: 'remote_command_config_reader_type',
        name: 'readerType',
        label: 'Reader Type',
        size: 8,
        component: 'NSelect',
        componentProps: { placeholder: 'Pick a reader type' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'remote_command_config_mode',
        name: 'mode',
        label: 'Mode',
        size: 8,
        component: 'NSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a mode',
          optionsData: [
            { value: 'EXEC', label: 'EXEC' },
            { value: 'LOGGER', label: 'LOGGER' },
            { value: 'SHELL', label: 'SHELL' },
          ],
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'remote_command_config_label',
        name: 'label',
        label: 'Label',
        size: 8,
        component: 'NInput',
        componentProps: { placeholder: 'Enter a label' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'remote_command_config_body',
        name: 'body',
        label: 'Body',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter a body' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'remote_command_config_description',
        name: 'description',
        label: 'Description',
        size: 24,
        component: 'NInput',
        componentProps: {
          placeholder: 'Enter a description',
          type: 'textarea',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'remote_command_config_params',
        name: 'params',
        label: 'Params',
        size: 24,
        component: '',
        defaultValue: [],
        componentProps: {},
        rules: [
          {
            required: false,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
